import React, { FC, useState } from 'react';
import { UploadAudioModal } from './upload-audio-modal';
import { UploadAudioIcon } from '../../icons/upload-audio-icon';

const TOOLTIP_TEXT =
  'Для аудиозаписей очных сессий. Если сессия прошла в ZiNGiZi — транскрибация и анализ встроены в видеозвонок.';
const TOOLTIP_ID = 'upload-audio-tooltip';

type UploadAudioWidgetProps = {
  /** Список имён клиентов для выбора в попапе (опционально). */
  clientNames?: string[];
};

export const UploadAudioWidget: FC<UploadAudioWidgetProps> = ({ clientNames = [] }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="relative w-full self-center flex justify-center">
      <button
        type="button"
        className="flex min-h-[126px] w-full flex-col items-center justify-center gap-[5px] rounded-[20px] border border-[#C00000] bg-[#F5F6FA] px-[30px] py-[15px] transition-colors hover:bg-[#ECEFFA] focus-visible:ring-2 focus-visible:ring-[#C00000] focus-visible:ring-offset-2"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        onClick={() => setModalOpen(true)}
        aria-describedby={showTooltip ? TOOLTIP_ID : undefined}
      >
        <UploadAudioIcon />
        <span className="font-comfortaa font-bold text-[14px] leading-[1.12] text-[#2C3038] text-center">
          Загрузить аудиозапись
        </span>
      </button>
      {showTooltip && (
        <div
          id={TOOLTIP_ID}
          role="tooltip"
          className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-20 w-[249px] px-2 py-1.5 rounded bg-[#2C3038] text-white text-[13px] leading-[1.23] font-normal shadow-[0px_1px_36px_-4px_rgba(38,39,40,0.1)] pointer-events-none"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-[#2C3038]" />
          {TOOLTIP_TEXT}
        </div>
      )}
      <UploadAudioModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        clientNames={clientNames}
      />
    </div>
  );
};

export default UploadAudioWidget;
